import { render } from "./4PelatihanKerja.vue?vue&type=template&id=1b035633"
import script from "./4PelatihanKerja.vue?vue&type=script&lang=js"
export * from "./4PelatihanKerja.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__